import { render, staticRenderFns } from "./SystemCallTimeChartsPage.vue?vue&type=template&id=e9b550f4&scoped=true&"
import script from "./SystemCallTimeChartsPage.vue?vue&type=script&lang=js&"
export * from "./SystemCallTimeChartsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b550f4",
  null
  
)

export default component.exports